import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { BasicPageContext } from '../../../context'
import style from './index.scss'

const StoreLink = props => {
  const store = props.store
  const centreSlug = props.centreSlug
  const url = `/${centreSlug}/store/${store.sys.id}/${store.slug}`
  return (
    <BasicPageContext.Consumer>
      {isBasicPage => {
        if (isBasicPage) {
          return store.title
        }
        return (
          <Link key={store.sys.id} to={url} className={style.nearestStore}>
            {store.title}
          </Link>
        )
      }}
    </BasicPageContext.Consumer>
  )
}

StoreLink.propTypes = {
  store: PropTypes.object,
  centreSlug: PropTypes.string,
}

export default StoreLink
